module.exports = __webpack_public_path__ + "static/media/bg_downgrade_suggestion_under_30.7691100d.webp";